import React, { useEffect, useState } from 'react';
// import { Card } from 'react-daisyui';
import { Link } from 'react-router-dom';
// import InformasiPublik from '../pages/InformasiPublik';
import requests from '../Requests';
import Loader from './Loader';

function LinkPermohonan() {

    const [katPemohonInformasi, setkatPemohonInformasi] = useState([]);
    const [isLoading, setIsLoading] = useState(true)

    const getKatPemohonInformasi = async () => {
        const dataKatPemohonInformasi = await fetch(requests.requestKatPemohonInfWithImage, {
            method: 'get',
            headers: new Headers({
                "Authorization": `Bearer ${requests.token_web}`
            })
        });
        const valueKatPemohonInformasi = await dataKatPemohonInformasi.json();
        const result = valueKatPemohonInformasi.data.map((valueKatPemohonInformasi) => {
            return {
                "id": valueKatPemohonInformasi.id,
                "judul_kategori": valueKatPemohonInformasi.attributes.judul_kategori,
                "slug": valueKatPemohonInformasi.attributes.Slug,
                "url_kategori": valueKatPemohonInformasi.attributes.url_kategori,
                "thumb_kategori": requests.base_url + valueKatPemohonInformasi.attributes.image_kategori.data.attributes.url,
            }
        })
        setkatPemohonInformasi(result);
        setIsLoading(false)
    }

    useEffect(() => {
        getKatPemohonInformasi();
        // console.log(katPemohonInformasi);
    }, [])

    return (
        <div
            className={`
        container
        flex
        flex-wrap
        justify-center
        gap-3
        p-4
        mx-auto
        ${isLoading ? 'items-center h-screen' : ''}
    `}
        >
            {isLoading && <Loader />}
            {!isLoading &&
                <>
                    {katPemohonInformasi.map((katPemohonInformasi) =>
                        <div
                            key={katPemohonInformasi.id}
                            className='overflow-hidden transition duration-300 border shadow-lg aspect-square w-28 sm:w-32 md:w-40 lg:w-48 rounded-2xl hover:scale-105 hover:bg-blue-kemdikbud'
                        >
                            <a href={katPemohonInformasi.url_kategori} target={katPemohonInformasi.url_kategori ? '_blank' : '_self'} rel="noreferrer" className='flex flex-col items-center justify-center w-full h-full p-4 text-center text-black hover:text-white'>
                                <img
                                    src={katPemohonInformasi.thumb_kategori}
                                    alt={katPemohonInformasi.judul_kategori}
                                    className='object-contain w-12 h-12 mb-2 sm:w-16 sm:h-16 md:w-20 md:h-20'
                                />
                                <span className='px-2 text-xs font-medium sm:text-sm md:text-base'>
                                    {katPemohonInformasi.judul_kategori}
                                </span>
                            </a>
                        </div>
                    )
                    }
                </>
            }
        </div>
    )
}

export default LinkPermohonan